import { putResolve } from 'redux-saga/effects'
import { addCondition } from 'src/store/loan'

import { Loan } from 'WebAPI'

export default function* ({ payload, meta }) {
  try {
    // yield call(Loan.addCondition, payload)

    //UPDATED API REQUEST loan_oper_api page: conditionadd
    const result = yield putResolve(addCondition(payload))
    if (!addCondition.fulfilled.match(result)) {
      throw { Error: { Message: result.payload } }
    }
    return meta.resolve('Condition was added')
  } catch (error) {
    meta.reject(error)
  }
}
